// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"313":"7616ed6a","802":"62a62df6"}[chunkId] + ".css";
};